import styled from "styled-components"

export default {
    "InternationalList": styled.div`
        height: 440px;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;
        padding: 12px;
        border: 1px solid ${({ theme }) => theme.color["grey2"]};
        border-radius: 4px;
    `,
    "InternationalElement": styled.div`
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px 0;
        cursor: pointer;
        
        & > h3 {
            ${({ theme }) => theme.font["medium-semibold"]};
        }

        & > p {
            ${({ theme }) => theme.font["medium-medium"]};
        }
    `,

    "Wrapper": styled.div`
        width: fit-content;
    `,
    "Select": styled.button`
        position: relative;
        width: fit-content; 
        height: 100%;
        display: flex;
        align-items: center;
        border: 1px solid ${({ theme }) => theme.color["grey3"]};
        border-radius: 4px;
        gap: 4px;

        & > p {
            padding: 0 20px 0 8px;
            color: ${({ theme }) => theme.color["black"]};
            ${({ theme }) => theme.font["large-medium"]};
            white-space: nowrap;
        }

        & > img {
            width: 8px;
            position: absolute;
            right: 8px;
        }
    `,
}